import { Tag } from "antd";
import CRUDTabTableModal from "../../../../components/CRUDTabTableModal";
import { useUserStore } from "../../../../stores/userStore";

function LabelWithTag({ label, tag }: { label: string; tag: string }) {
	return (
		<div className="flex items-center justify-between gap-5">
			<div>{label}</div>
			<Tag>{tag}</Tag>
		</div>
	);
}

interface TenantReportingLookupProps {
	readOnly?: boolean;
}

function TenantReportingLookup({ readOnly }: TenantReportingLookupProps) {
	const user = useUserStore((state) => state.user);

	return (
		<CRUDTabTableModal
			items={[
				{
					label: "Departments",
					key: "departments",
					directoryName: "Departments directory",
					configurationName: "Departments configuration",
				},
				{
					label: <LabelWithTag label="Category" tag="MoC" />,
					key: "moc_categories",
					directoryName: "MoC category directory",
					configurationName: "MoC category configuration",
				},
				// {
				// 	label: <LabelWithTag label="Consequences" tag="Incident" />,
				// 	key: "consequences",
				// 	directoryName: "Consequence directory",
				// 	configurationName: "Consequence configuration",
				// },
				{
					label: <LabelWithTag label="HTO" tag="Incident" />,
					key: "mto_categories",
					directoryName: "HTO directory",
					configurationName: "HTO configuration",
				},
				{
					label: <LabelWithTag label="Probability" tag="Incident" />,
					key: "probabilities",
					directoryName: "Probability directory",
					configurationName: "Probability configuration",
				},
				// {
				// 	label: <LabelWithTag label="Risk matrix" tag="Incident" />,
				// 	key: "risk_matrix",
				// 	directoryName: "Risk matrix directory",
				// 	configurationName: "Risk matrix configuration",
				// },
			]}
			tabkey="departments"
			user={user}
			readOnly={readOnly}
			headerName="Configurations (Reporting)"
		/>
	);
}

export default TenantReportingLookup;
